import type { DistinguishedFolderIdName } from '../../service/eager/contracts';

export const rootContactFolderDistinguishedName: DistinguishedFolderIdName = 'usercuratedcontacts';
